export function decodeHTMLEntities(encodedString: string): string {
  if (typeof document !== 'undefined') {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = encodedString;
    return textArea.value;
  } else return '';
}
